import ReactGA from 'react-ga';

const gaId = 'UA-76164688-8';

ReactGA.initialize(gaId, {debug: false});

export default ReactGA;



// WEBPACK FOOTER //
// ./src/components/ga.js